<script lang="ts">
	import Carousel from '$lib/carousel.svelte';
	import PageGrid from '../components/pageGrid.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			member: Array<ISbStoryData['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="overflow-x-hidden">
	<PageGrid>
		<section class="col-span-full my-8">
			<h1
				class="mb-3 text-pretty text-[24px]/[110%] font-semibold text-brown-2 lg:mb-11 lg:text-[32px]"
			>
				{content.title}
			</h1>

			<Carousel class="mt-4 flex gap-x-4" overflow>
				{#each content.member as member}
					<div
						class="flex-none basis-[75%] overflow-hidden rounded-2xl sm:basis-[40%] lg:basis-[calc(20%-12px)]"
					>
						<Blok content={member} />
					</div>
				{/each}
			</Carousel>
		</section>
	</PageGrid>
</div>
